import * as ko from "knockout";
import Bao from "./../services/bao-service";
import SearchPaging from "./../factories/search-paging";
import BaoDialogViewModel from "./../factories/bao-dialog";
function SoftwareLicenceTypeViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(SoftwareLicenceTypeViewModel, SearchPaging);
SoftwareLicenceTypeViewModel.prototype.PrimaryKey = "SoftwareLicenceTypeId";
SoftwareLicenceTypeViewModel.prototype.RefreshUrl = "SoftwareLicenceType/Get";
SoftwareLicenceTypeViewModel.prototype.SaveUrl = "SoftwareLicenceType/Save";
SoftwareLicenceTypeViewModel.prototype.DeleteUrl = "SoftwareLicenceType/Delete";
SoftwareLicenceTypeViewModel.prototype.IsInUseUrl = "SoftwareLicenceType/IsInUse";
SoftwareLicenceTypeViewModel.prototype.PermissionForward = "SoftwareLicenceTypeMoveForward";
SoftwareLicenceTypeViewModel.prototype.PermissionBackward = "SoftwareLicenceTypeMoveBackward";
SoftwareLicenceTypeViewModel.prototype.PermissionSave = "SoftwareLicenceTypeSave";
SoftwareLicenceTypeViewModel.prototype.PermissionRefresh = "SoftwareLicenceTypeRefresh";
SoftwareLicenceTypeViewModel.prototype.PermissionDelete = "SoftwareLicenceTypeDelete";
export default SoftwareLicenceTypeViewModel;